import dayjs from 'dayjs';

import { useUnauthorizedEventsQuery } from '@queries/EventQueries';
import { useSeriesByTagSlug, useSeriesEntertainersQuery } from '@queries/TagQueries';

import { useCityById } from '@hooks/useCurrentUserLocation';

export const useCityDragKingSeriesEvents = (cityId: string) => {
  const { city } = useCityById(cityId);

  const { isFetched: isSeriesReady, series } = useSeriesByTagSlug(
    city?.featuredSeries?.kingsThings,
  );

  return useUnauthorizedEventsQuery(
    {
      tagIds: [series?._id],
      startDate: dayjs().format('YYYY-MM-DD'),
      rsvpData: 'ignore',
    },
    Boolean(series?._id),
  );
};
